// src/pages/TableSelection.tsx
import React, { useEffect, useState } from 'react';
import { fetchTableList, fetchOrderDetails, updateTableStatus } from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { Tables } from '../utils/types';
import { useOrderType } from '../hooks/useOrderType';
import { useCart } from '../context/CartContext'; // Import the cart context


const TableSelection: React.FC = () => {
    // const { updateOrderType } = useOrderType();
    const { cartItems, updateQuantity, removeFromCart, clearCart, setCartItems } = useCart();

    const [tables, setTables] = useState<Tables[]>([]);
    const [groupedTables, setGroupedTables] = useState<Record<string, Tables[]>>({});
    const [selectedLocation, setSelectedLocation] = useState<string>('');
    const [selectedTable, setSelectedTable] = useState<Tables | null>(null);
    const navigate = useNavigate();
    // const [orderType, setOrderType] = useState<string>(
    //     localStorage.getItem('orderType') || 'Takeaway'
    // );
    const { orderType, updateOrderType } = useOrderType();

    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const vendorId = userData.vendor_id; // Get vendor ID from user data

    // Fetch tables and group them by location
    useEffect(() => {
        const loadTables = async () => {
            try {
                const data = await fetchTableList();
                // console.log('Table data:', data);

                const grouped = data.reduce((acc: Record<string, Tables[]>, table: Tables) => {
                    const location = table.location.toUpperCase();
                    if (!acc[location]) {
                        acc[location] = [];
                    }
                    acc[location].push(table);
                    return acc;
                }, {});
                setTables(data);
                setGroupedTables(grouped);

                // Automatically select the first location as the default tab
                const locations = Object.keys(grouped);
                if (locations.length > 0) {
                    setSelectedLocation(locations[0]);
                }
                updateOrderType('Dine In');
            } catch (error) {
                console.error('Error fetching table list:', error);
            }
        };

        loadTables();
    }, [vendorId, updateOrderType]);

    const handleTableSelect = async (currentTable: Tables) => {

        let currSelectedTable = localStorage.setItem('currSelectedTable', currentTable.tableName);
        // console.log('stb tbs>', currSelectedTable);

        if (currentTable.orderId) {
            try {
                // Fetch order details
                const orderDetails = await fetchOrderDetails(currentTable.vendorId, currentTable.orderId);
                

                if (orderDetails.status !== 'pending') {
                    // Navigate to order details for inspection
                    navigate(`/order-details/${currentTable.orderId}`);
                    // alert(`Table ${currentTable.tableName} is linked to a non-pending order. Please review the order.`);

                    // If the order is completed or canceled, unlink the table
                    if (['paid', 'cancel', 'completed'].includes(orderDetails.status)) {
                        await updateTableStatus(
                            Number(currentTable.vendorId),
                            Number(currentTable.id),
                            'vacant', // Reset table status
                            null, // Remove the orderId
                            null // Remove the customerId
                        );
                        
                        alert(`Table ${currentTable.tableName} has been unlinked from order #${currentTable.orderId}`);
                    }
                    return;
                }
            } catch (error) {
                console.error('Error fetching order details:', error);
                alert('Failed to fetch order details. Please try again.');
                return;
            }
        }

        // Handle vacant table selection
        if (currentTable.status === 'vacant') {

            // const isConfirmed = window.confirm(
            //     `Please confirm that system will clear the current cart for new order.`
            // );

            // if (isConfirmed) {
                clearCart();
                // Clear relevant session data
                localStorage.removeItem('existingOrderId');
                localStorage.removeItem('checkedOutItems');
                localStorage.removeItem('selectedTable');
                localStorage.removeItem('orderId');

                // Explicitly reset state to ensure no leftover values
                // setOrderId(null);  // Assuming `orderId` is a state variable
                setCartItems([]);   // Clear the cart

                // Optionally reset any other relevant states
                setSelectedTable(null);
                updateOrderType('');

                navigate('/'); // Redirect to a page (home or otherwise) to refresh the session
            // }

            // currentTable.status = 'occupied'; // Update local state
            setSelectedTable(currentTable);

            updateOrderType('Dine In');
            localStorage.setItem('selectedTableId', JSON.stringify(currentTable.id));
            localStorage.setItem('selectedTable', JSON.stringify(currentTable));
            localStorage.setItem('orderType', 'Dine In');

            // navigate(-1);
            navigate('/');
        } else if (currentTable.status === 'occupied' && currentTable.orderId) {
            navigate('/order-details/' + currentTable.orderId);
        } else if (currentTable.status === 'locked') {
            alert(`Table ${currentTable.tableName} is currently locked.`);

        } else {
        alert(`Table ${currentTable.tableName} is currently occupied.`);
}
    };



    const handleOrderTypeChange = (selectedOrderType: string) => {
        updateOrderType(selectedOrderType); // Update the orderType in context
    };


    const handleTabClick = (location: string) => {
        setSelectedLocation(location);
    };

    const handleAddOrder = async (table: Tables) => {
        if (!table.orderId) return;

        try {

            const orderDetails = await fetchOrderDetails(vendorId, table.orderId);

            if (orderDetails.status === 'pending') {
                // const isConfirmed = window.confirm(
                //     `Please confirm that the Extra Order will clear the current cart for order #${table.orderId}.`
                // );

                // if (isConfirmed) {
                // Clear the cart (assumes you have a function like clearCart to manage this)
                clearCart(); // Replace with your actual cart-clearing logic

                // Clear the cart if necessary
                localStorage.setItem('orderId', table.orderId.toString());

                let currSelectedTable = localStorage.setItem('currSelectedTable', table.tableName);
                // console.log('stb tbs add order>', currSelectedTable);

                // Navigate to the ExtraOrder page
                // navigate(`/cart?orderId=${table.orderId}`);
                navigate(`/`);

                // } else {
                //     alert('Order update cancelled.');
                // }

            } else {
                alert(`Order #${table.orderId} is not in a pending state.`);
            }

        } catch (error) {
            console.error('Error fetching order details:', error);
            alert('Failed to fetch order details. Please try again.');
        }
    };


    return (
        <div className="table-selection-container">
            <h3 className="pageTitle">Select a Table</h3>

            {/* <div className="order-type-selector">
                <label className="text-sm font-bold">Order Type: </label>
                <div className="flex gap-4 mt-2">
                    <label className="flex items-center">
                        <input
                            type="radio"
                            name="orderType"
                            value="Dine In"
                            checked={orderType === "Dine In"} // Ensure the radio button reflects the current orderType
                            onChange={(e) => handleOrderTypeChange(e.target.value)} // Handle change to update state
                            className="mr-2"
                        />
                        Dine In
                    </label>
                    <label className="flex items-center">
                        <input
                            type="radio"
                            name="orderType"
                            value="Takeaway"
                            checked={orderType === "Takeaway"} // Ensure the radio button reflects the current orderType
                            onChange={(e) => handleOrderTypeChange(e.target.value)} // Handle change to update state
                            className="mr-2"
                        />
                        Takeaway
                    </label>
                </div>
            </div> */}

            {/* Tabs for locations */}
            <div className="tabs flex flex-wrap justify-center m-0 p-0">
                {Object.keys(groupedTables).map((location) => (
                    <button
                        key={location}
                        onClick={() => handleTabClick(location)}
                        className={`table-tab tab rounded-md ${selectedLocation === location
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-200 text-gray-800'
                            }`}
                    >
                        {location}
                    </button>
                ))}
            </div>


            <div className="table-list-container">

                {orderType === 'Dine In' && (

                    <ul className="table-list mt-4">
                        {groupedTables[selectedLocation]?.map((table) => (
                            <li
                                key={table.id}
                                className={`table-item 
            ${(() => {
                                        switch (table.status) {
                                            case 'occupied':
                                                return 'bg-red-200';
                                            case 'vacant':
                                                return 'bg-green-200';
                                            case 'locked':
                                                return 'bg-gray-200';
                                            default:
                                                return '';
                                        }
                                    })()} rounded-lg p-1 shadow-md flex justify-between items-center relative`}

                            >
                                <div onClick={() => handleTableSelect(table)} className='w-full h-full p-0 m-0'>
                                    <p className="text-xl font-bold">{table.tableName.toUpperCase()}</p>
                                    {table.orderId && (
                                        <p className="text-purple-700 text-sm font-normal">#{table.orderId}</p>
                                    )}

                                    {table.orderId && (
                                        <button
                                            className="ActionBtn w-20 text-white  "
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevent triggering table selection
                                                handleAddOrder(table);
                                            }}
                                            style={{ backgroundColor: '#7a75b5' }}
                                        >
                                            Add Order
                                        </button>
                                    )}
                                </div>

                                {!table.orderId && (
                                    <div className=' absolute top-0 right-0   bg-red-600 text-white p-1' onClick={() => navigate('/tables/' + table.id)}>R</div>
                                )}

                            </li>
                        ))}
                    </ul>

                )}

                {orderType === 'Takeaway' && (
                    <p className="text-sm text-gray-500 mt-4">No table selection required for Takeaway.</p>
                )}
            </div>
            {selectedTable && (
                <div className="selected-table">
                    <p>Selected Table: {selectedTable.tableName}</p>
                </div>
            )}
        </div>
    );
};

export default TableSelection;
